{
  "bgm": {
    "volume": 40,
    "tracks": [
      { "src": "resources/music/synthwave_1.4.wav", "seconds": 76.8 },
      { "src": "resources/music/darksynth - 2021-02-19, 8.06 PM.mp3", "seconds": 105.5 },
      { "src": "resources/music/tune_a - 2020-10-29, 12.06 AM.mp3", "seconds": 59.4 }
    ]
  },
  "sfx": {
    "volume": 70,
    "sustained": ["crunch", "fire"],
    "map": {
      "blast": "resources/sounds/ima_firin_my_lazer-mastercard-1442368741_1.mp3",
      "boom": "resources/sounds/universfield-shotgun-blast-352038.mp3",
      "meow": "resources/sounds/dragon-studio-cat-meow-401729.mp3",
      "crunch": "resources/sounds/freesound_community-eating-cereal-close-71002.mp3",
      "kaching": "resources/sounds/freesound_community-cha-ching-7053.mp3",
      "gusta": "resources/sounds/me-gusta.mp3",
      "whoosh": "resources/sounds/fine.mp3",
      "blip": "resources/sounds/lizard-button.mp3",
      "grapple-whoosh": "resources/sounds/grapple-whoosh.wav",
      "grapple-blip": "resources/sounds/grapple-blip.wav",
      "dodgeball-launch": "resources/sounds/dodgeball-launch.wav",
      "fish-launch": "resources/sounds/fish-launch.wav",
      "bork": "resources/sounds/u_5wgfa0ekjt-dog-bark-179915.mp3",
      "fish": "resources/sounds/fish-meme-sfx.mp3",
      "fire": "resources/sounds/soundreality-fire-sound-334130.mp3"
    },
    "gain": {
      "blast": 0.1,
      "meow": 0.4,
      "boom": 0.7,
      "fire": 0.5,
      "grapple-whoosh": 0.7,
      "grapple-blip": 0.75,
      "dodgeball-launch": 0.75,
      "fish-launch": 0.8
    }
  }
}
